/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////
export { DEFAULT_PROPS } from './default-props';

/////////////////////////////////////////////
// COLOR CONFIGURATION
/////////////////////////////////////////////
export const BG_COLOR = {
  primary: '#f9f1e6',
  secondary: '#550001',
  alternative: '#b8a487',
};

export const TEXT_COLOR = {
  primary: '#1a1b1d',
  secondary: '#fef8f3',
  alternative: '#830000',
};

export const NAVIGATION_COLOR = {
  base: BG_COLOR.alternative,
  icon: `#FFF`,
};

